<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc" title="Contents">Contents</h2>
<p class="firstverse"><a href="#/Text/Preface">Preface</a></p>
<p class="firstverse"><a href="#/Text/ch1">1: A Violinist and a Pastor</a></p>
<p class="firstverse"><a href="#/Text/ch2">2: In Whose Eyes?</a></p>
<p class="firstverse"><span href="#/Text/ch3" title="Link target outside of Sample">3: Success in the Eyes of God</span></p>
<p class="firstverse"><span href="#/Text/ch4" title="Link target outside of Sample">4: Experiencing Failure</span></p>
<p class="firstverse"><span href="#/Text/ch5" title="Link target outside of Sample">5: Grappling with Failure Theologically</span></p>
<p class="firstverse"><span href="#/Text/ch6" title="Link target outside of Sample">6: More Truths of Grace</span></p>
<p class="firstverse"><span href="#/Text/ch7" title="Link target outside of Sample">7: Responding to Failure</span></p>
<p class="firstverse"><span href="#/Text/ch8" title="Link target outside of Sample">8: Helping Others</span></p>
<p class="firstverse"><span href="#/Text/Epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="firstverse"><span href="#/Text/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="firstverse"><span href="#/Text/ScriptureIndex" title="Link target outside of Sample">Scripture Index</span></p>
<p class="firstverse"><span href="#/Text/endorsements" title="Link target outside of Sample">Praise for <em>What God Thinks When We Fail</em></span></p>
<p class="firstverse"><span href="#/Text/author" title="Link target outside of Sample">About the Author</span></p>
<p class="firstverse"><span href="#/Text/MoreTitlesfromIVP" title="Link target outside of Sample">More Titles From InterVarsity Press</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?769d1a4a